// =============================================================================
// SITE CONFIGURATION — Le Rond Point (Montrouge)
// =============================================================================
// Master configuration for Le Rond Point restaurant & brasserie website.
// Controls styling, localization, reservations, SEO, and integrations.
// =============================================================================

import type { SiteConfig } from '@webzite/content-schema';

const siteConfig: SiteConfig = {
  // =========================================================================
  // VISUAL STYLE
  // =========================================================================
  // Le Rond Point style pack — authentic Montrouge Parisian corner brasserie
  // (brasserie vermilion red, bistro zinc charcoal, warm brass, and ivory linen).
  stylePack: 'le-rond-point',

  // =========================================================================
  // GEOGRAPHIC REGION
  // =========================================================================
  // European Union — EU-14 allergen regulations, GDPR cookie consent.
  region: 'eu',

  // =========================================================================
  // LANGUAGE & LOCALIZATION
  // =========================================================================
  defaultLocale: 'fr',
  locales: ['fr', 'en', 'zh', 'de', 'it', 'pt'],
  currency: 'EUR',

  // =========================================================================
  // RESERVATIONS
  // =========================================================================
  reservations: {
    enabled: true,
    provider: 'custom',
    bookingUrl: 'tel:+33142535098',
  },

  // =========================================================================
  // DELIVERY PLATFORMS
  // =========================================================================
  delivery: {
    enabled: false,
    platforms: [],
  },

  // =========================================================================
  // MAP
  // =========================================================================
  maps: {
    provider: 'osm',
    embedUrl:
      'https://www.openstreetmap.org/export/embed.html?bbox=2.3060,48.8130,2.3160,48.8180&layer=mapnik&marker=48.8159207,2.3111607',
    googleMapsLink:
      'https://www.google.com/maps/place/Le+Rond+Point/@48.8159207,2.3111607,17z/data=!4m17!1m10!3m9!1s0x47e670f890ee6f91:0x6c728fdc71dd1c0f!2sLe+Rond+Point!8m2!3d48.8159207!4d2.3111607!10e5!14m1!1BCgIgAQ!16s%2Fg%2F1tcxn_19!3m5!1s0x47e670f890ee6f91:0x6c728fdc71dd1c0f!8m2!3d48.8159207!4d2.3111607!16s%2Fg%2F1tcxn_19',
    appleMapsLink:
      'https://maps.apple.com/?q=Le+Rond+Point+18+Place+Jean+Jaures+92120+Montrouge',
  },

  // =========================================================================
  // ANALYTICS
  // =========================================================================
  analytics: {
    cloudflare: { enabled: true },
    ga4: {
      enabled: false,
      measurementId: '',
    },
  },

  // =========================================================================
  // SEO (Search Engine Optimization)
  // =========================================================================
  seo: {
    titleTemplate: '%s | Le Rond Point — Brasserie & Restaurant Traditionnel · Montrouge',
    defaultDescription:
      'Brasserie au 18 Place Jean Jaurès, Montrouge. Viandes de qualité, tartare au couteau, burgers maison, terrasse conviviale et service continu.',
    ogImage: '/images/og-image.png',
  },

  // =========================================================================
  // DEVELOPER ATTRIBUTION & WATERMARK
  // =========================================================================
  developer: {
    name: 'jeduapf',
    url: 'https://portfolio.jeduapf.com',
    role: 'Restaurant Web Developer',
    showFooterCredit: true,
  },

  // =========================================================================
  // ALLERGEN REGULATION
  // =========================================================================
  allergenRegulation: 'eu-fic-1169',
};

export default siteConfig;
